var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1833V8.28333H11.5167V14.1833H0ZM1.56667 11.2667H9.93333V9.85H1.56667V11.2667ZM5.75 8.28333L2.03333 3.83333C2.03333 2.78889 2.39283 1.88889 3.11183 1.13333C3.83083 0.377778 4.71022 0 5.75 0C6.78978 0 7.66917 0.377778 8.38817 1.13333C9.10717 1.88889 9.46667 2.78889 9.46667 3.83333L5.75 8.28333ZM5.75 6L7.8 3.33333C7.71111 2.84078 7.47467 2.42594 7.09067 2.08883C6.70667 1.75183 6.25944 1.58333 5.749 1.58333C5.23856 1.58333 4.79167 1.75183 4.40833 2.08883C4.025 2.42594 3.78889 2.84078 3.7 3.33333L5.75 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingStatus);
export default __webpack_public_path__ + "static/media/pending_status.2e2a386878b8e92044cc46051ad05fd8.svg";
export { ForwardRef as ReactComponent };